import React from 'react';
import {Link} from 'react-router-dom';


export function FooterSectionTitle(props){
  return(<h5 className="small text-uppercase mt-5 mb-3 text-white">{props.title}</h5>)
}


export function FooterLink(props){
  return (
    <div className={"uppercase m-2 text-spacing-2 text-size-3"}>
      <Link className="black-bb-1-1 text-dark-3" to={props.to}><i className="text-black-8"></i>{props.text}</Link>
    </div>  
  )
}

export function FooterExtLink(props){
  return (
    <div className={"uppercase m-2 text-spacing-2 text-size-3 "}>
      <a href={props.href} className="black-bb-1-1 text-dark-3"><i className="text-black-8"></i>{props.text}</a>
    </div>  
  )
}
